(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 7314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9812);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Index": function() { return /* binding */ Index; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(2779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/awesome-debounce-promise/dist/index.es.js + 2 modules
var index_es = __webpack_require__(9147);
;// CONCATENATED MODULE: ../../libs/utils/src/hooks/use-event-tracking.tsx



const useClickEventTracking = (ref, context, event, options)=>{
    const { trackEvent  } = (0,react.useContext)(context);
    (0,react.useEffect)(()=>{
        const nodeElement = ref === null || ref === void 0 ? void 0 : ref.current;
        const trackClickEvent = ()=>{
            trackEvent(event, options);
        };
        nodeElement === null || nodeElement === void 0 ? void 0 : nodeElement.addEventListener("click", trackClickEvent);
        return ()=>{
            nodeElement === null || nodeElement === void 0 ? void 0 : nodeElement.removeEventListener("click", trackClickEvent);
        };
    }, [
        trackEvent,
        options,
        event,
        ref
    ]);
};
const useInputTypingEventTracking = function(ref, context, event, options) {
    let shouldTrackTerms = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    const { trackEvent  } = useContext(context);
    const [inputValue, setInputValue] = useState("");
    const prevInputValue = usePrevious(inputValue);
    useEffect(()=>{
        const nodeElement = ref === null || ref === void 0 ? void 0 : ref.current;
        const trackChangeEvent = AwesomeDebouncePromise(()=>{
            var ref1;
            const newValue = "".concat((ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.value) || "");
            setInputValue(newValue);
        }, 1000);
        nodeElement === null || nodeElement === void 0 ? void 0 : nodeElement.addEventListener("input", trackChangeEvent);
        return ()=>{
            nodeElement === null || nodeElement === void 0 ? void 0 : nodeElement.removeEventListener("input", trackChangeEvent);
        };
    }, [
        ref
    ]);
    useEffect(()=>{
        if (inputValue && inputValue !== prevInputValue || !inputValue && prevInputValue) {
            trackEvent(event, {
                ...options,
                terms: shouldTrackTerms && inputValue
            });
        }
    }, [
        inputValue,
        prevInputValue,
        event,
        options,
        trackEvent,
        shouldTrackTerms
    ]);
};

// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
;// CONCATENATED MODULE: ../../libs/data-access/src/lib/types.generated.ts
/* eslint-disable */ var AccountStatus;
(function(AccountStatus) {
    AccountStatus["Disabled"] = "DISABLED";
    AccountStatus["Enabled"] = "ENABLED";
})(AccountStatus || (AccountStatus = {}));
var Availability;
(function(Availability) {
    Availability["Immediate"] = "IMMEDIATE";
    Availability["OpenToOffers"] = "OPEN_TO_OFFERS";
    Availability["Unavailable"] = "UNAVAILABLE";
})(Availability || (Availability = {}));
var BillingCycleSortFields;
(function(BillingCycleSortFields) {
    BillingCycleSortFields["Id"] = "_id";
    BillingCycleSortFields["Closed"] = "closed";
    BillingCycleSortFields["CompanyId"] = "companyId";
    BillingCycleSortFields["CreatedAt"] = "createdAt";
    BillingCycleSortFields["EndDate"] = "endDate";
    BillingCycleSortFields["EngagementId"] = "engagementId";
    BillingCycleSortFields["ExpectedHours"] = "expectedHours";
    BillingCycleSortFields["InvoiceId"] = "invoiceId";
    BillingCycleSortFields["StartDate"] = "startDate";
    BillingCycleSortFields["TalentUserId"] = "talentUserId";
})(BillingCycleSortFields || (BillingCycleSortFields = {}));
var BillingSortFields;
(function(BillingSortFields) {
    BillingSortFields["Id"] = "_id";
    BillingSortFields["Code"] = "code";
    BillingSortFields["CompanyId"] = "companyId";
    BillingSortFields["CompanyName"] = "company__name";
    BillingSortFields["CreatedAt"] = "createdAt";
    BillingSortFields["DueDate"] = "dueDate";
    BillingSortFields["NotesNote"] = "notes__note";
    BillingSortFields["PeriodEnd"] = "periodEnd";
    BillingSortFields["PeriodStart"] = "periodStart";
    BillingSortFields["Status"] = "status";
    BillingSortFields["StatusSortingOrder"] = "statusSortingOrder";
    BillingSortFields["Total"] = "total";
    BillingSortFields["UpdatedAt"] = "updatedAt";
})(BillingSortFields || (BillingSortFields = {}));
var BillingStatus;
(function(BillingStatus) {
    BillingStatus["Complete"] = "COMPLETE";
    BillingStatus["Created"] = "CREATED";
    BillingStatus["PaymentReceived"] = "PAYMENT_RECEIVED";
    BillingStatus["TransferredToWallet"] = "TRANSFERRED_TO_WALLET";
    BillingStatus["TransferFailed"] = "TRANSFER_FAILED";
    BillingStatus["TransferInProgress"] = "TRANSFER_IN_PROGRESS";
    BillingStatus["WaitingForPayment"] = "WAITING_FOR_PAYMENT";
    BillingStatus["WaitingForPaymentDelayed"] = "WAITING_FOR_PAYMENT_DELAYED";
})(BillingStatus || (BillingStatus = {}));
var CareerPath;
(function(CareerPath) {
    CareerPath["Generalist"] = "GENERALIST";
    CareerPath["Leader"] = "LEADER";
    CareerPath["Specialist"] = "SPECIALIST";
})(CareerPath || (CareerPath = {}));
var CompanyOptionalPopulates;
(function(CompanyOptionalPopulates) {
    CompanyOptionalPopulates["ActiveEngagementsCount"] = "activeEngagementsCount";
})(CompanyOptionalPopulates || (CompanyOptionalPopulates = {}));
var CompanyPlatformService;
(function(CompanyPlatformService) {
    CompanyPlatformService["CompanyKit"] = "COMPANY_KIT";
    CompanyPlatformService["GiveBonus"] = "GIVE_BONUS";
    CompanyPlatformService["ScaleTeam"] = "SCALE_TEAM";
    CompanyPlatformService["TalentRetention"] = "TALENT_RETENTION";
})(CompanyPlatformService || (CompanyPlatformService = {}));
var CompanySortFields;
(function(CompanySortFields) {
    CompanySortFields["Id"] = "_id";
    CompanySortFields["ActiveEngagementsCount"] = "activeEngagementsCount";
    CompanySortFields["BusinessType"] = "businessType";
    CompanySortFields["CreatedAt"] = "createdAt";
    CompanySortFields["EngagementManagerId"] = "engagementManagerId";
    CompanySortFields["EngagementUserIds"] = "engagementUserIds";
    CompanySortFields["JoinedOn"] = "joinedOn";
    CompanySortFields["Location"] = "location";
    CompanySortFields["Name"] = "name";
    CompanySortFields["NotesNote"] = "notes__note";
    CompanySortFields["Status"] = "status";
    CompanySortFields["TeamSize"] = "teamSize";
    CompanySortFields["UpdatedAt"] = "updatedAt";
    CompanySortFields["UserIds"] = "userIds";
})(CompanySortFields || (CompanySortFields = {}));
var CompanyStatus;
(function(CompanyStatus) {
    CompanyStatus["Active"] = "ACTIVE";
    CompanyStatus["Inactive"] = "INACTIVE";
})(CompanyStatus || (CompanyStatus = {}));
var CompanyUserInvitationSortFields;
(function(CompanyUserInvitationSortFields) {
    CompanyUserInvitationSortFields["CompanyId"] = "companyId";
    CompanyUserInvitationSortFields["Email"] = "email";
    CompanyUserInvitationSortFields["FirstName"] = "firstName";
    CompanyUserInvitationSortFields["InvitedById"] = "invitedById";
    CompanyUserInvitationSortFields["LastName"] = "lastName";
    CompanyUserInvitationSortFields["Status"] = "status";
})(CompanyUserInvitationSortFields || (CompanyUserInvitationSortFields = {}));
var ContractType;
(function(ContractType) {
    ContractType["DirectPlacement"] = "DIRECT_PLACEMENT";
    ContractType["MsaSow"] = "MSA_SOW";
})(ContractType || (ContractType = {}));
var EngagementSortFields;
(function(EngagementSortFields) {
    EngagementSortFields["Id"] = "_id";
    EngagementSortFields["Code"] = "code";
    EngagementSortFields["CompanyContractSigned"] = "companyContractSigned";
    EngagementSortFields["CompanyContractSignedDate"] = "companyContractSignedDate";
    EngagementSortFields["CompanyId"] = "companyId";
    EngagementSortFields["CompanyName"] = "company__name";
    EngagementSortFields["ContractType"] = "contractType";
    EngagementSortFields["CreatedAt"] = "createdAt";
    EngagementSortFields["CurrentCycleId"] = "currentCycleId";
    EngagementSortFields["CyclesCreatedAt"] = "cyclesCreatedAt";
    EngagementSortFields["EndDate"] = "endDate";
    EngagementSortFields["EngagementManagerUserId"] = "engagementManagerUserId";
    EngagementSortFields["ExpectedHoursPerWeek"] = "expectedHoursPerWeek";
    EngagementSortFields["ExperienceStartDate"] = "experienceStartDate";
    EngagementSortFields["ExternalPayment"] = "externalPayment";
    EngagementSortFields["HourlyRate"] = "hourlyRate";
    EngagementSortFields["InvoiceDueBusinessDays"] = "invoiceDueBusinessDays";
    EngagementSortFields["InvoiceDuePeriod"] = "invoiceDuePeriod";
    EngagementSortFields["JobCode"] = "jobCode";
    EngagementSortFields["JobId"] = "jobId";
    EngagementSortFields["ManagerEmail"] = "manager__email";
    EngagementSortFields["ManagerFirstName"] = "manager__firstName";
    EngagementSortFields["ManagerFullName"] = "manager__fullName";
    EngagementSortFields["ManagerLastName"] = "manager__lastName";
    EngagementSortFields["MonthlySalary"] = "monthlySalary";
    EngagementSortFields["NextCycleId"] = "nextCycleId";
    EngagementSortFields["NextEngagementId"] = "nextEngagementId";
    EngagementSortFields["NotesNote"] = "notes__note";
    EngagementSortFields["OfferMadeAt"] = "offerMadeAt";
    EngagementSortFields["PaymentCycle"] = "paymentCycle";
    EngagementSortFields["PaymentType"] = "paymentType";
    EngagementSortFields["PreviousEngagementId"] = "previousEngagementId";
    EngagementSortFields["ServiceType"] = "serviceType";
    EngagementSortFields["StartDate"] = "startDate";
    EngagementSortFields["Status"] = "status";
    EngagementSortFields["TakeRate"] = "takeRate";
    EngagementSortFields["TalentContractSigned"] = "talentContractSigned";
    EngagementSortFields["TalentContractSignedDate"] = "talentContractSignedDate";
    EngagementSortFields["TalentUserId"] = "talentUserId";
    EngagementSortFields["TalentEmail"] = "talent__email";
    EngagementSortFields["TalentFirstName"] = "talent__firstName";
    EngagementSortFields["TalentFullName"] = "talent__fullName";
    EngagementSortFields["TalentLastName"] = "talent__lastName";
    EngagementSortFields["TerminationDate"] = "terminationDate";
    EngagementSortFields["WorkContractType"] = "workContractType";
})(EngagementSortFields || (EngagementSortFields = {}));
var EngagementStatus;
(function(EngagementStatus) {
    EngagementStatus["Active"] = "ACTIVE";
    EngagementStatus["Completed"] = "COMPLETED";
    EngagementStatus["Draft"] = "DRAFT";
    EngagementStatus["StartingSoon"] = "STARTING_SOON";
    EngagementStatus["Terminated"] = "TERMINATED";
    EngagementStatus["TrialPeriod"] = "TRIAL_PERIOD";
})(EngagementStatus || (EngagementStatus = {}));
var EnglishProficiency;
(function(EnglishProficiency) {
    EnglishProficiency["Advanced"] = "ADVANCED";
    EnglishProficiency["Basic"] = "BASIC";
    EnglishProficiency["Intermediate"] = "INTERMEDIATE";
})(EnglishProficiency || (EnglishProficiency = {}));
var Evaluation;
(function(Evaluation) {
    Evaluation["Helpful"] = "HELPFUL";
    Evaluation["NotHelpful"] = "NOT_HELPFUL";
})(Evaluation || (Evaluation = {}));
var FinancialEntitySortFields;
(function(FinancialEntitySortFields) {
    FinancialEntitySortFields["Id"] = "_id";
    FinancialEntitySortFields["CreatedAt"] = "createdAt";
    FinancialEntitySortFields["TalentUserId"] = "talentUserId";
})(FinancialEntitySortFields || (FinancialEntitySortFields = {}));
var Group;
(function(Group) {
    Group["Admin"] = "ADMIN";
    Group["Business"] = "BUSINESS";
    Group["Engagement"] = "ENGAGEMENT";
    Group["Financial"] = "FINANCIAL";
    Group["Growth"] = "GROWTH";
})(Group || (Group = {}));
var InvitationStatus;
(function(InvitationStatus) {
    InvitationStatus["Complete"] = "COMPLETE";
    InvitationStatus["Invited"] = "INVITED";
})(InvitationStatus || (InvitationStatus = {}));
var InvoiceDueType;
(function(InvoiceDueType) {
    InvoiceDueType["BusinessDays"] = "BUSINESS_DAYS";
    InvoiceDueType["ConsecutiveDays"] = "CONSECUTIVE_DAYS";
})(InvoiceDueType || (InvoiceDueType = {}));
var InvoiceHuskyStatus;
(function(InvoiceHuskyStatus) {
    InvoiceHuskyStatus["AvailableToWithdraw"] = "AVAILABLE_TO_WITHDRAW";
    InvoiceHuskyStatus["ComplianceDocumentRequired"] = "COMPLIANCE_DOCUMENT_REQUIRED";
    InvoiceHuskyStatus["Creating"] = "CREATING";
    InvoiceHuskyStatus["Failed"] = "FAILED";
    InvoiceHuskyStatus["NoFundsAvailable"] = "NO_FUNDS_AVAILABLE";
    InvoiceHuskyStatus["Paid"] = "PAID";
    InvoiceHuskyStatus["Paying"] = "PAYING";
    InvoiceHuskyStatus["Processing"] = "PROCESSING";
    InvoiceHuskyStatus["RequestReceived"] = "REQUEST_RECEIVED";
    InvoiceHuskyStatus["Validating"] = "VALIDATING";
    InvoiceHuskyStatus["Withdrawn"] = "WITHDRAWN";
})(InvoiceHuskyStatus || (InvoiceHuskyStatus = {}));
var InvoiceSortFields;
(function(InvoiceSortFields) {
    InvoiceSortFields["Id"] = "_id";
    InvoiceSortFields["BillingCode"] = "billingCode";
    InvoiceSortFields["ChargeableValue"] = "chargeableValue";
    InvoiceSortFields["Code"] = "code";
    InvoiceSortFields["CompanyId"] = "companyId";
    InvoiceSortFields["CompanyName"] = "company__name";
    InvoiceSortFields["CreatedAt"] = "createdAt";
    InvoiceSortFields["CycleId"] = "cycleId";
    InvoiceSortFields["DueDate"] = "dueDate";
    InvoiceSortFields["EngagementId"] = "engagementId";
    InvoiceSortFields["ExternalPayment"] = "externalPayment";
    InvoiceSortFields["FinancialEntityId"] = "financialEntityId";
    InvoiceSortFields["IsCustomInvoice"] = "isCustomInvoice";
    InvoiceSortFields["IsPlatformInvoice"] = "isPlatformInvoice";
    InvoiceSortFields["LegalEntityId"] = "legalEntityId";
    InvoiceSortFields["NotesNote"] = "notes__note";
    InvoiceSortFields["Number"] = "number";
    InvoiceSortFields["PeriodEnd"] = "periodEnd";
    InvoiceSortFields["PeriodStart"] = "periodStart";
    InvoiceSortFields["RateBrl"] = "rateBRL";
    InvoiceSortFields["Status"] = "status";
    InvoiceSortFields["TakeRate"] = "takeRate";
    InvoiceSortFields["TalentUserId"] = "talentUserId";
    InvoiceSortFields["TalentEmail"] = "talent__email";
    InvoiceSortFields["TalentFirstName"] = "talent__firstName";
    InvoiceSortFields["TalentFullName"] = "talent__fullName";
    InvoiceSortFields["TalentLastName"] = "talent__lastName";
    InvoiceSortFields["Total"] = "total";
    InvoiceSortFields["TotalBrl"] = "totalBRL";
})(InvoiceSortFields || (InvoiceSortFields = {}));
var InvoiceStatus;
(function(InvoiceStatus) {
    InvoiceStatus["Complete"] = "COMPLETE";
    InvoiceStatus["Created"] = "CREATED";
    InvoiceStatus["MissingFinancialEntity"] = "MISSING_FINANCIAL_ENTITY";
    InvoiceStatus["PaymentReceived"] = "PAYMENT_RECEIVED";
    InvoiceStatus["PendingReview"] = "PENDING_REVIEW";
    InvoiceStatus["TransferredToWallet"] = "TRANSFERRED_TO_WALLET";
    InvoiceStatus["TransferFailed"] = "TRANSFER_FAILED";
    InvoiceStatus["TransferInProgress"] = "TRANSFER_IN_PROGRESS";
    InvoiceStatus["WaitingForPayment"] = "WAITING_FOR_PAYMENT";
    InvoiceStatus["WaitingForPaymentDelayed"] = "WAITING_FOR_PAYMENT_DELAYED";
})(InvoiceStatus || (InvoiceStatus = {}));
var JobCandidateCommunicationChannel;
(function(JobCandidateCommunicationChannel) {
    JobCandidateCommunicationChannel["Another"] = "ANOTHER";
    JobCandidateCommunicationChannel["Email"] = "EMAIL";
    JobCandidateCommunicationChannel["Slack"] = "SLACK";
    JobCandidateCommunicationChannel["Whatsapp"] = "WHATSAPP";
})(JobCandidateCommunicationChannel || (JobCandidateCommunicationChannel = {}));
var JobCandidateHistoryEvent;
(function(JobCandidateHistoryEvent) {
    JobCandidateHistoryEvent["FlagAdded"] = "FLAG_ADDED";
    JobCandidateHistoryEvent["FlagRemoved"] = "FLAG_REMOVED";
    JobCandidateHistoryEvent["StageChanged"] = "STAGE_CHANGED";
})(JobCandidateHistoryEvent || (JobCandidateHistoryEvent = {}));
var JobCandidateSortFields;
(function(JobCandidateSortFields) {
    JobCandidateSortFields["Id"] = "_id";
    JobCandidateSortFields["ArchiveReason"] = "archiveReason";
    JobCandidateSortFields["AssigneeUserId"] = "assigneeUserId";
    JobCandidateSortFields["CreatedAt"] = "createdAt";
    JobCandidateSortFields["JobId"] = "jobId";
    JobCandidateSortFields["JobSeniority"] = "job__seniority";
    JobCandidateSortFields["JobSkills"] = "job__skills";
    JobCandidateSortFields["JobStatus"] = "job__status";
    JobCandidateSortFields["LastStage"] = "lastStage";
    JobCandidateSortFields["Stage"] = "stage";
    JobCandidateSortFields["UpdatedAt"] = "updatedAt";
    JobCandidateSortFields["UserId"] = "userId";
    JobCandidateSortFields["UserEmail"] = "user__email";
    JobCandidateSortFields["UserFullName"] = "user__fullName";
})(JobCandidateSortFields || (JobCandidateSortFields = {}));
var JobCandidateSource;
(function(JobCandidateSource) {
    JobCandidateSource["ExpressMatching"] = "EXPRESS_MATCHING";
    JobCandidateSource["TalentPool"] = "TALENT_POOL";
    JobCandidateSource["Waitlist"] = "WAITLIST";
})(JobCandidateSource || (JobCandidateSource = {}));
var JobCandidateStage;
(function(JobCandidateStage) {
    JobCandidateStage["Archived"] = "ARCHIVED";
    JobCandidateStage["ContractSignature"] = "CONTRACT_SIGNATURE";
    JobCandidateStage["KickOffAlignments"] = "KICK_OFF_ALIGNMENTS";
    JobCandidateStage["Matching"] = "MATCHING";
    JobCandidateStage["PreMatching"] = "PRE_MATCHING";
    JobCandidateStage["Proposal"] = "PROPOSAL";
    JobCandidateStage["Sourcing"] = "SOURCING";
    JobCandidateStage["Vetting"] = "VETTING";
})(JobCandidateStage || (JobCandidateStage = {}));
var JobSortFields;
(function(JobSortFields) {
    JobSortFields["Id"] = "_id";
    JobSortFields["ArchiveReason"] = "archiveReason";
    JobSortFields["CandidatesAssigneeUserId"] = "candidates__assigneeUserId";
    JobSortFields["CandidatesFullName"] = "candidates__fullName";
    JobSortFields["Code"] = "code";
    JobSortFields["CompanyId"] = "companyId";
    JobSortFields["CompanyName"] = "companyName";
    JobSortFields["EngagementManagerUserId"] = "engagementManagerUserId";
    JobSortFields["Position"] = "position";
    JobSortFields["Seniority"] = "seniority";
    JobSortFields["SkillsName"] = "skills__name";
    JobSortFields["Status"] = "status";
    JobSortFields["UpdatedAt"] = "updatedAt";
})(JobSortFields || (JobSortFields = {}));
var JobStatus;
(function(JobStatus) {
    JobStatus["Active"] = "ACTIVE";
    JobStatus["Archived"] = "ARCHIVED";
    JobStatus["Completed"] = "COMPLETED";
    JobStatus["Draft"] = "DRAFT";
    JobStatus["OnHold"] = "ON_HOLD";
    JobStatus["PendingCandidates"] = "PENDING_CANDIDATES";
    JobStatus["Recruiting"] = "RECRUITING";
})(JobStatus || (JobStatus = {}));
var LearningCategory;
(function(LearningCategory) {
    LearningCategory["All"] = "ALL";
    LearningCategory["Audiobook"] = "AUDIOBOOK";
    LearningCategory["Book"] = "BOOK";
    LearningCategory["Course"] = "COURSE";
    LearningCategory["Interactive"] = "INTERACTIVE";
    LearningCategory["LearningPath"] = "LEARNING_PATH";
    LearningCategory["LiveEvents"] = "LIVE_EVENTS";
    LearningCategory["Playlist"] = "PLAYLIST";
    LearningCategory["PracticeExams"] = "PRACTICE_EXAMS";
    LearningCategory["Video"] = "VIDEO";
})(LearningCategory || (LearningCategory = {}));
var LearningContentType;
(function(LearningContentType) {
    LearningContentType["Article"] = "ARTICLE";
    LearningContentType["Audiobook"] = "AUDIOBOOK";
    LearningContentType["Book"] = "BOOK";
    LearningContentType["CaseStudy"] = "CASE_STUDY";
    LearningContentType["Course"] = "COURSE";
    LearningContentType["LearningPath"] = "LEARNING_PATH";
    LearningContentType["LiveEvent"] = "LIVE_EVENT";
    LearningContentType["Playlist"] = "PLAYLIST";
    LearningContentType["PracticeExam"] = "PRACTICE_EXAM";
    LearningContentType["Sandbox"] = "SANDBOX";
    LearningContentType["Scenario"] = "SCENARIO";
    LearningContentType["Video"] = "VIDEO";
})(LearningContentType || (LearningContentType = {}));
var LegalEntitySortFields;
(function(LegalEntitySortFields) {
    LegalEntitySortFields["Id"] = "_id";
    LegalEntitySortFields["CompanyId"] = "companyId";
    LegalEntitySortFields["CreatedAt"] = "createdAt";
})(LegalEntitySortFields || (LegalEntitySortFields = {}));
var Locale;
(function(Locale) {
    Locale["En"] = "EN";
    Locale["PtBr"] = "PT_BR";
})(Locale || (Locale = {}));
var PaymentCycle;
(function(PaymentCycle) {
    PaymentCycle["BiWeekly"] = "BI_WEEKLY";
    PaymentCycle["Monthly"] = "MONTHLY";
    PaymentCycle["SemiMonthly"] = "SEMI_MONTHLY";
})(PaymentCycle || (PaymentCycle = {}));
var PaymentType;
(function(PaymentType) {
    PaymentType["FlatFee"] = "FLAT_FEE";
    PaymentType["Flexible"] = "FLEXIBLE";
})(PaymentType || (PaymentType = {}));
var ProfileOnboardingStep;
(function(ProfileOnboardingStep) {
    ProfileOnboardingStep["Complete"] = "COMPLETE";
    ProfileOnboardingStep["Step_1"] = "STEP_1";
    ProfileOnboardingStep["Step_2"] = "STEP_2";
    ProfileOnboardingStep["Step_3"] = "STEP_3";
    ProfileOnboardingStep["Step_4"] = "STEP_4";
})(ProfileOnboardingStep || (ProfileOnboardingStep = {}));
var ProfilePreferredRole;
(function(ProfilePreferredRole) {
    ProfilePreferredRole["Backend"] = "BACKEND";
    ProfilePreferredRole["Design"] = "DESIGN";
    ProfilePreferredRole["Devops"] = "DEVOPS";
    ProfilePreferredRole["Frontend"] = "FRONTEND";
    ProfilePreferredRole["Fullstack"] = "FULLSTACK";
    ProfilePreferredRole["Management"] = "MANAGEMENT";
    ProfilePreferredRole["Mobile"] = "MOBILE";
    ProfilePreferredRole["QaEngineer"] = "QA_ENGINEER";
})(ProfilePreferredRole || (ProfilePreferredRole = {}));
var ProfileReviewStatus;
(function(ProfileReviewStatus) {
    ProfileReviewStatus["Approved"] = "APPROVED";
    ProfileReviewStatus["Incomplete"] = "INCOMPLETE";
    ProfileReviewStatus["PendingOlbyReview"] = "PENDING_OLBY_REVIEW";
    ProfileReviewStatus["PendingReport"] = "PENDING_REPORT";
    ProfileReviewStatus["WaitingTalentReview"] = "WAITING_TALENT_REVIEW";
})(ProfileReviewStatus || (ProfileReviewStatus = {}));
var ProfileSortFields;
(function(ProfileSortFields) {
    ProfileSortFields["Id"] = "_id";
    ProfileSortFields["Availability"] = "availability";
    ProfileSortFields["EnglishProficiency"] = "englishProficiency";
    ProfileSortFields["EnglishScore"] = "englishScore";
    ProfileSortFields["ExpectedSalaryFrom"] = "expectedSalaryFrom";
    ProfileSortFields["ExpectedSalaryTo"] = "expectedSalaryTo";
    ProfileSortFields["FillingPercentage"] = "fillingPercentage";
    ProfileSortFields["LinkedinHandle"] = "linkedinHandle";
    ProfileSortFields["MainSkillsExperience"] = "mainSkills__experience";
    ProfileSortFields["MainSkillsSkillId"] = "mainSkills__skillId";
    ProfileSortFields["NotesNote"] = "notes__note";
    ProfileSortFields["ReferralCode"] = "referralCode";
    ProfileSortFields["ReferredByUserId"] = "referredByUserId";
    ProfileSortFields["ReviewStatus"] = "reviewStatus";
    ProfileSortFields["SkillsSkillId"] = "skills__skillId";
    ProfileSortFields["SoftSkillsScore"] = "softSkillsScore";
    ProfileSortFields["Status"] = "status";
    ProfileSortFields["Title"] = "title";
    ProfileSortFields["UserActive"] = "user__active";
    ProfileSortFields["UserCreatedAt"] = "user__createdAt";
    ProfileSortFields["UserEmail"] = "user__email";
    ProfileSortFields["UserFirstName"] = "user__firstName";
    ProfileSortFields["UserFullName"] = "user__fullName";
    ProfileSortFields["UserLastName"] = "user__lastName";
    ProfileSortFields["VettingFinishedAt"] = "vettingFinishedAt";
    ProfileSortFields["VettingStatus"] = "vettingStatus";
    ProfileSortFields["WorkableId"] = "workableId";
    ProfileSortFields["WorkableRecruiterName"] = "workableRecruiterName";
    ProfileSortFields["WorkableStage"] = "workableStage";
    ProfileSortFields["WorkableUrl"] = "workableUrl";
    ProfileSortFields["YearsOfExperience"] = "yearsOfExperience";
})(ProfileSortFields || (ProfileSortFields = {}));
var ProfileStatus;
(function(ProfileStatus) {
    ProfileStatus["Active"] = "ACTIVE";
    ProfileStatus["Available"] = "AVAILABLE";
    ProfileStatus["Inactive"] = "INACTIVE";
    ProfileStatus["Matching"] = "MATCHING";
})(ProfileStatus || (ProfileStatus = {}));
var PublicMatchingSkillSortFields;
(function(PublicMatchingSkillSortFields) {
    PublicMatchingSkillSortFields["Id"] = "_id";
    PublicMatchingSkillSortFields["Name"] = "name";
    PublicMatchingSkillSortFields["SecondaryName"] = "secondaryName";
})(PublicMatchingSkillSortFields || (PublicMatchingSkillSortFields = {}));
var ReferralType;
(function(ReferralType) {
    ReferralType["Events"] = "EVENTS";
    ReferralType["Other"] = "OTHER";
    ReferralType["OurWebsite"] = "OUR_WEBSITE";
    ReferralType["Referral"] = "REFERRAL";
    ReferralType["SocialMedia"] = "SOCIAL_MEDIA";
})(ReferralType || (ReferralType = {}));
var RemoveMainSkill;
(function(RemoveMainSkill) {
    RemoveMainSkill["MoveToAdditional"] = "MOVE_TO_ADDITIONAL";
    RemoveMainSkill["RemoveFromProfile"] = "REMOVE_FROM_PROFILE";
})(RemoveMainSkill || (RemoveMainSkill = {}));
var types_generated_Role;
(function(Role) {
    Role["Backoffice"] = "BACKOFFICE";
    Role["Company"] = "COMPANY";
    Role["Global"] = "GLOBAL";
    Role["Talent"] = "TALENT";
})(types_generated_Role || (types_generated_Role = {}));
var Seniority;
(function(Seniority) {
    Seniority["Junior"] = "JUNIOR";
    Seniority["MidLevel"] = "MID_LEVEL";
    Seniority["Senior"] = "SENIOR";
})(Seniority || (Seniority = {}));
var ServiceType;
(function(ServiceType) {
    ServiceType["ProductDesign"] = "PRODUCT_DESIGN";
    ServiceType["ProjectManagement"] = "PROJECT_MANAGEMENT";
    ServiceType["SoftwareDevelopment"] = "SOFTWARE_DEVELOPMENT";
})(ServiceType || (ServiceType = {}));
var SkillExperience;
(function(SkillExperience) {
    SkillExperience["BetweenOneAndTwo"] = "BETWEEN_ONE_AND_TWO";
    SkillExperience["BetweenSixAndTen"] = "BETWEEN_SIX_AND_TEN";
    SkillExperience["BetweenThreeAndFive"] = "BETWEEN_THREE_AND_FIVE";
    SkillExperience["LessThanOne"] = "LESS_THAN_ONE";
    SkillExperience["MoreThanTen"] = "MORE_THAN_TEN";
})(SkillExperience || (SkillExperience = {}));
var SkillSortFields;
(function(SkillSortFields) {
    SkillSortFields["Id"] = "_id";
    SkillSortFields["Name"] = "name";
    SkillSortFields["SecondaryName"] = "secondaryName";
})(SkillSortFields || (SkillSortFields = {}));
var SortDirection;
(function(SortDirection) {
    SortDirection["Asc"] = "ASC";
    SortDirection["Desc"] = "DESC";
})(SortDirection || (SortDirection = {}));
var SortNulls;
(function(SortNulls) {
    SortNulls["NullsFirst"] = "NULLS_FIRST";
    SortNulls["NullsLast"] = "NULLS_LAST";
})(SortNulls || (SortNulls = {}));
var SortingDirection;
(function(SortingDirection) {
    SortingDirection["Asc"] = "ASC";
    SortingDirection["Desc"] = "DESC";
})(SortingDirection || (SortingDirection = {}));
var SourceOrigin;
(function(SourceOrigin) {
    SourceOrigin["Other"] = "OTHER";
    SourceOrigin["TalentPool"] = "TALENT_POOL";
    SourceOrigin["Waitlist"] = "WAITLIST";
})(SourceOrigin || (SourceOrigin = {}));
var SourcingSortFields;
(function(SourcingSortFields) {
    SourcingSortFields["Id"] = "_id";
    SourcingSortFields["CandidateFullName"] = "candidate__fullName";
    SourcingSortFields["CreatedAt"] = "createdAt";
    SourcingSortFields["JobId"] = "job___id";
    SourcingSortFields["JobCode"] = "job__code";
    SourcingSortFields["JobSeniority"] = "job__seniority";
    SourcingSortFields["JobSkills"] = "job__skills";
    SourcingSortFields["JobStatus"] = "job__status";
    SourcingSortFields["Origin"] = "origin";
    SourcingSortFields["RecruiterFullName"] = "recruiter__fullName";
})(SourcingSortFields || (SourcingSortFields = {}));
var TeamSize;
(function(TeamSize) {
    TeamSize["FiftyToOneHundred"] = "FIFTY_TO_ONE_HUNDRED";
    TeamSize["FiveHundredToOneThousand"] = "FIVE_HUNDRED_TO_ONE_THOUSAND";
    TeamSize["MoreThanOneThousand"] = "MORE_THAN_ONE_THOUSAND";
    TeamSize["OneHundredToFiveHundred"] = "ONE_HUNDRED_TO_FIVE_HUNDRED";
    TeamSize["OneToTen"] = "ONE_TO_TEN";
    TeamSize["TenToFifty"] = "TEN_TO_FIFTY";
})(TeamSize || (TeamSize = {}));
var TermType;
(function(TermType) {
    TermType["CookiePolicy"] = "COOKIE_POLICY";
    TermType["PrivacyPolicy"] = "PRIVACY_POLICY";
    TermType["TermsOfUse"] = "TERMS_OF_USE";
})(TermType || (TermType = {}));
var TimeTrackingTool;
(function(TimeTrackingTool) {
    TimeTrackingTool["Harvest"] = "HARVEST";
    TimeTrackingTool["Jira"] = "JIRA";
    TimeTrackingTool["Toggl"] = "TOGGL";
})(TimeTrackingTool || (TimeTrackingTool = {}));
var UserSortFields;
(function(UserSortFields) {
    UserSortFields["Id"] = "_id";
    UserSortFields["AcceptedTerms"] = "acceptedTerms";
    UserSortFields["Active"] = "active";
    UserSortFields["CreatedAt"] = "createdAt";
    UserSortFields["Email"] = "email";
    UserSortFields["FirstName"] = "firstName";
    UserSortFields["FullName"] = "fullName";
    UserSortFields["Groups"] = "groups";
    UserSortFields["LastName"] = "lastName";
    UserSortFields["Role"] = "role";
    UserSortFields["VerifiedEmail"] = "verifiedEmail";
})(UserSortFields || (UserSortFields = {}));
var UserTheme;
(function(UserTheme) {
    UserTheme["Dark"] = "DARK";
    UserTheme["DefaultBrowserSettings"] = "DEFAULT_BROWSER_SETTINGS";
    UserTheme["Light"] = "LIGHT";
})(UserTheme || (UserTheme = {}));
var VettingStatus;
(function(VettingStatus) {
    VettingStatus["Approved"] = "APPROVED";
    VettingStatus["Blocked"] = "BLOCKED";
    VettingStatus["Declined"] = "DECLINED";
    VettingStatus["InProgress"] = "IN_PROGRESS";
    VettingStatus["Pending"] = "PENDING";
    VettingStatus["Skipped"] = "SKIPPED";
    VettingStatus["WaitingList"] = "WAITING_LIST";
})(VettingStatus || (VettingStatus = {}));
var WorkContractType;
(function(WorkContractType) {
    WorkContractType["FullTime"] = "FULL_TIME";
    WorkContractType["PartTime"] = "PART_TIME";
})(WorkContractType || (WorkContractType = {}));
var WorkingExperience;
(function(WorkingExperience) {
    WorkingExperience["Associate"] = "ASSOCIATE";
    WorkingExperience["MidLevel"] = "MID_LEVEL";
    WorkingExperience["Principal"] = "PRINCIPAL";
    WorkingExperience["Senior"] = "SENIOR";
})(WorkingExperience || (WorkingExperience = {}));
var WorklogCategory;
(function(WorklogCategory) {
    WorklogCategory["Development"] = "DEVELOPMENT";
    WorklogCategory["Meetings"] = "MEETINGS";
    WorklogCategory["Others"] = "OTHERS";
})(WorklogCategory || (WorklogCategory = {}));
var WorklogSortFields;
(function(WorklogSortFields) {
    WorklogSortFields["Id"] = "_id";
    WorklogSortFields["Category"] = "category";
    WorklogSortFields["CompanyId"] = "companyId";
    WorklogSortFields["CreatedAt"] = "createdAt";
    WorklogSortFields["CreatedBy"] = "createdBy";
    WorklogSortFields["CycleId"] = "cycleId";
    WorklogSortFields["EngagementId"] = "engagementId";
    WorklogSortFields["InvoiceId"] = "invoiceId";
    WorklogSortFields["SecondsSpent"] = "secondsSpent";
    WorklogSortFields["TalentUserId"] = "talentUserId";
    WorklogSortFields["WorkedAt"] = "workedAt";
})(WorklogSortFields || (WorklogSortFields = {}));
var Core__Purpose;
(function(Core__Purpose) {
    Core__Purpose[/** `EXECUTION` features provide metadata necessary to for operation execution. */ "Execution"] = "EXECUTION";
    Core__Purpose[/** `SECURITY` features provide metadata necessary to securely resolve fields. */ "Security"] = "SECURITY";
})(Core__Purpose || (Core__Purpose = {}));
var Join__Graph;
(function(Join__Graph) {
    Join__Graph["Authentication"] = "AUTHENTICATION";
    Join__Graph["Company"] = "COMPANY";
    Join__Graph["Engagement"] = "ENGAGEMENT";
    Join__Graph["Payment"] = "PAYMENT";
    Join__Graph["Profile"] = "PROFILE";
})(Join__Graph || (Join__Graph = {}));

;// CONCATENATED MODULE: ../../libs/utils/src/lib/amplitude/index.tsx




const INITIAL_STATE = {
    trackEvent: ()=>{
        return;
    },
    enabled: false
};
const AmplitudeContext = /*#__PURE__*/ (0,react.createContext)(INITIAL_STATE);
const useAmplitude = (apiKey)=>{
    const router = useRouter();
    const [isAmplitudeInitialized, setAmplitudeInitialized] = useState(false);
    const [amplitudeValue, setAmplitudeValue] = useState(INITIAL_STATE);
    // Initialize Amplitude
    useEffect(()=>{
        const initAmplitude = async ()=>{
            if (router.isReady && apiKey) {
                await init(apiKey).promise;
                setAmplitudeInitialized(true);
            }
        };
        initAmplitude();
    }, [
        router.isReady
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    useEffect(()=>{
        if (isAmplitudeInitialized) {
            setAmplitudeValue({
                trackEvent: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    track(...args);
                },
                enabled: true
            });
        }
    }, [
        isAmplitudeInitialized
    ]);
    // Track router changes
    useEffect(()=>{
        if (isAmplitudeInitialized) {
            track("app_load", {
                pathname: router.pathname,
                query: router.query
            });
        }
        const registerRouteChange = (asPath)=>{
            if (isAmplitudeInitialized) {
                track("page_change", {
                    pathname: asPath
                });
            }
        };
        router.events.on("routeChangeComplete", registerRouteChange);
        return ()=>{
            router.events.off("routeChangeComplete", registerRouteChange);
        };
    }, [
        isAmplitudeInitialized
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    return amplitudeValue;
};
const TALENT_STAGES = {
    [ProfileStatus.Active]: "ACTIVE_ENGAGEMENT",
    [ProfileStatus.Matching]: "TALENT_POOL",
    [ProfileStatus.Available]: "TALENT_POOL",
    [ProfileStatus.Inactive]: "INACTIVE"
};
const AmplitudeUserSetup = ()=>{
    var ref, ref1;
    const { data: talentUserData  } = useUserQuery(undefined, {
        enabled: false
    });
    const { data: companyUserData  } = useCompanyUserQuery(undefined, {
        enabled: false
    });
    const { enabled  } = useContext(AmplitudeContext);
    const identifyEvent = useMemo(()=>new Identify(), []);
    const data = (companyUserData === null || companyUserData === void 0 ? void 0 : companyUserData.getMe) || (talentUserData === null || talentUserData === void 0 ? void 0 : talentUserData.getMe);
    const isCompany = (data === null || data === void 0 ? void 0 : data.role) === Role.Company;
    const isTalent = (data === null || data === void 0 ? void 0 : data.role) === Role.Talent;
    useEffect(()=>{
        if (enabled && (data === null || data === void 0 ? void 0 : data._id)) {
            var ref, ref1;
            setUserId(data === null || data === void 0 ? void 0 : data._id);
            identifyEvent.set("user_role", data.role);
            if (isCompany && ((ref = companyUserData === null || companyUserData === void 0 ? void 0 : companyUserData.getMe.companies) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name)) {
                var ref2, ref3;
                identifyEvent.set("company_name", (ref2 = companyUserData === null || companyUserData === void 0 ? void 0 : companyUserData.getMe.companies) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.name);
            }
            if (isTalent) {
                var ref4, ref5;
                const userStatus = talentUserData === null || talentUserData === void 0 ? void 0 : (ref4 = talentUserData.getMe) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.profile) === null || ref5 === void 0 ? void 0 : ref5.status;
                identifyEvent.set("talent_stage", TALENT_STAGES[userStatus]);
            }
            identify(identifyEvent);
        }
    }, [
        companyUserData === null || companyUserData === void 0 ? void 0 : companyUserData.getMe.companies,
        data,
        enabled,
        identifyEvent,
        isCompany,
        isTalent,
        talentUserData === null || talentUserData === void 0 ? void 0 : (ref = talentUserData.getMe) === null || ref === void 0 ? void 0 : (ref1 = ref.profile) === null || ref1 === void 0 ? void 0 : ref1.status
    ]);
    return null;
};

// EXTERNAL MODULE: ../../node_modules/slugify/slugify.js
var slugify_slugify = __webpack_require__(6854);
;// CONCATENATED MODULE: ../../libs/utils/src/lib/helpers.ts
/* provided dependency */ var process = __webpack_require__(4406);
var ref;


const capitalizeString = (string)=>{
    if (!string) {
        return "";
    }
    return string[0].toUpperCase() + string.slice(1).toLowerCase();
};
const formatCurrencyToNumber = (value)=>{
    var ref;
    if (!value) {
        return 0;
    }
    return typeof value === "number" ? value : Number(value === null || value === void 0 ? void 0 : (ref = value.replaceAll) === null || ref === void 0 ? void 0 : ref.call(value, ",", ""));
};
const numberFormatter = Intl.NumberFormat("en", {
    style: "currency",
    currency: "USD"
});
const numberFormatterNoDecimals = Intl.NumberFormat("en", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0
});
const numberFormatterBRL = Intl.NumberFormat("en", {
    style: "currency",
    currency: "BRL"
});
const valueToCurrency = (value, noDecimals)=>"".concat((noDecimals ? numberFormatterNoDecimals : numberFormatter).format(value), " USD");
const valueToBRLCurrency = (value)=>numberFormatterBRL.format(value);
const getCurrencyToInput = (value)=>{
    if (value.charAt(0) === "$") {
        return value.slice(1);
    }
    return value.slice(0, 1) + value.slice(2);
};
const appUrl =  true && ((ref = window.location) === null || ref === void 0 ? void 0 : ref.host) || process.env.NEXT_PUBLIC_TALENT_URL_HOST || "";
const isExternalUrl = (url)=>{
    return !(!url || (url === null || url === void 0 ? void 0 : url[0]) === "/" || (url === null || url === void 0 ? void 0 : url[0]) === "?" || url.includes(appUrl)) || (url === null || url === void 0 ? void 0 : url.includes("mailto:")) || (url === null || url === void 0 ? void 0 : url.includes("blob"));
};
const formatUrl = (url)=>{
    if (!url) {
        return "";
    }
    if ((url === null || url === void 0 ? void 0 : url[0]) === "/" || (url === null || url === void 0 ? void 0 : url[0]) === "?" || url.includes("mailto:") || url.includes("blob")) {
        return url;
    }
    if (url.includes(appUrl)) {
        return url.split(appUrl)[1];
    }
    if (url.includes("http")) {
        return url;
    }
    if ((url === null || url === void 0 ? void 0 : url[0]) === "#") {
        return url;
    }
    return "https://".concat(url);
};
const urlWithProtocol = (url)=>url && url.includes("http") ? url : "https://".concat(url);
const DEFAULT_BROWSER_SETTINGS = "DEFAULT_BROWSER_SETTINGS";
const getUserTheme = (selectedTheme)=>{
    // If user the theme to be default browser settings, check browser information
    if (selectedTheme === DEFAULT_BROWSER_SETTINGS || !selectedTheme) {
        const darkThemeMq =  true && window.matchMedia("(prefers-color-scheme: dark)").matches;
        return darkThemeMq ? "dark" : "light";
    }
    // Otherwise, just sent user selected value
    return selectedTheme === null || selectedTheme === void 0 ? void 0 : selectedTheme.toLocaleLowerCase();
};
const isMainNavActiveRoute = (currentUrl, link)=>{
    var ref, ref1;
    if (currentUrl === link) {
        return true;
    }
    const currentUrlMainRoute = (ref = currentUrl.split("/").filter((route)=>route !== "")) === null || ref === void 0 ? void 0 : ref[0];
    const linkMainRoute = (ref1 = link.split("/").filter((route)=>route !== "")) === null || ref1 === void 0 ? void 0 : ref1[0];
    if (linkMainRoute === null || linkMainRoute === void 0 ? void 0 : linkMainRoute.includes("?")) {
        const [linkMainRouterWithoutSort] = linkMainRoute.split("?");
        return currentUrlMainRoute === linkMainRouterWithoutSort;
    }
    return currentUrlMainRoute === linkMainRoute;
};
const formatReferral = (referralOnUrl, referralOnForm)=>{
    var ref;
    if (!referralOnUrl && !referralOnForm) {
        return undefined;
    }
    return (ref = referralOnUrl || referralOnForm) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase();
};
const sanitizeStringSpaces = (str)=>{
    // Remove spaces from string edges and duplicated spaces in the middle
    return str.trim().replace(REMOVE_DOUBLE_SPACE_REGEX, " ");
};
const replaceState = (newUrl)=>{
    window.history.replaceState({
        ...window.history.state,
        as: newUrl.href,
        url: newUrl.href
    }, "", newUrl.href);
};
const formatWebsitePostCategory = (categorySlug)=>{
    if (!categorySlug || Array.isArray(categorySlug)) {
        return "";
    }
    const category = categorySlug.replace(/-/, " ");
    const categoryFormatted = category[0].toUpperCase() + category.substring(1);
    return categoryFormatted;
};
const nestLayout = (param)=>{
    let { parent , child  } = param;
    return (page)=>{
        return parent(child(page));
    };
};
const formatPostsCategory = (categoryList)=>{
    if (!categoryList) {
        return {
            highlightedCategories: [],
            moreOptionsCategories: []
        };
    }
    const formattedCategories = categoryList.map((category)=>({
            label: category.name || "",
            href: "/blog/".concat(slugify(category.name || "", {
                lower: true
            }))
        }));
    const [firstCategory, secondCategory, thirdCategory, fourthCategory, fifthCategory, sixthCategory, ...moreOptions] = formattedCategories;
    return {
        highlightedCategories: [
            firstCategory,
            ...secondCategory ? [
                secondCategory
            ] : [],
            ...thirdCategory ? [
                thirdCategory
            ] : [],
            ...fourthCategory ? [
                fourthCategory
            ] : [],
            ...fifthCategory ? [
                fifthCategory
            ] : [],
            ...sixthCategory ? [
                sixthCategory
            ] : []
        ],
        moreOptionsCategories: moreOptions
    };
};

;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/icons/cta-arrow.svg
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgCtaArrow = function SvgCtaArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.16327 15.5L6.35957 13.7887L11.0943 9.25744H0V6.74256H11.0943L6.35957 2.21875L8.16327 0.5L16 8L8.16327 15.5Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgCtaArrow);

/* harmony default export */ var cta_arrow = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMTYzMjcgMTUuNUw2LjM1OTU3IDEzLjc4ODdMMTEuMDk0MyA5LjI1NzQ0SDBWNi43NDI1NkgxMS4wOTQzTDYuMzU5NTcgMi4yMTg3NUw4LjE2MzI3IDAuNUwxNiA4TDguMTYzMjcgMTUuNVoiLz4KPC9zdmc+Cg==");
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/button/index.module.scss
var index_module = __webpack_require__(8579);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/button/index.tsx







const CTAButton = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { className ="" , href , variant ="highlight" , size ="large" , children , trackingIdentifier , prefetch , isExternal =false , ...rest } = param;
    const classes = classnames_default()((index_module_default()).link, (index_module_default())[variant], (index_module_default())[size], className);
    const innerRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, ()=>innerRef.current);
    useClickEventTracking(innerRef, AmplitudeContext, "website_button_click", {
        id: trackingIdentifier
    });
    const formattedUrl = isExternal ? href : formatUrl(href);
    const renderChildren = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (index_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (index_module_default())["arrow-wrapper"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardRef, {
                        className: (index_module_default()).icon
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (index_module_default())["button-label"],
                    children: children
                })
            ]
        });
    }, [
        children
    ]);
    if (isExternalUrl(href) || isExternal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: formattedUrl,
            className: classes,
            ref: innerRef,
            ...rest,
            children: renderChildren
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: formattedUrl,
        prefetch: prefetch,
        className: classes,
        ref: innerRef,
        ...rest,
        children: renderChildren
    });
});
/* harmony default export */ var components_button = ((/* unused pure expression or super */ null && (CTAButton)));

;// CONCATENATED MODULE: ../../libs/ui-kit/src/lib/assets/logos/olby-logo.svg
var olby_logo_path;
var olby_logo_excluded = ["title", "titleId"];
function olby_logo_extends() { olby_logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return olby_logo_extends.apply(this, arguments); }
function olby_logo_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = olby_logo_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function olby_logo_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgOlbyLogo = function SvgOlbyLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = olby_logo_objectWithoutProperties(_ref, olby_logo_excluded);
  return /*#__PURE__*/react.createElement("svg", olby_logo_extends({
    width: 62,
    height: 32,
    viewBox: "0 0 62 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, olby_logo_path || (olby_logo_path = /*#__PURE__*/react.createElement("path", {
    d: "M37.5866 7.20466C35.9181 7.20466 34.3585 7.66872 33.0291 8.47499V0H28.7817V16.0102C28.7817 20.873 32.7238 24.8156 37.5872 24.8156C42.4506 24.8156 46.3927 20.8736 46.3927 16.0102C46.3927 11.1467 42.45 7.20466 37.5866 7.20466ZM37.5866 20.684C35.0053 20.684 32.9127 18.5914 32.9127 16.0102C32.9127 13.4289 35.0053 11.3363 37.5866 11.3363C40.1679 11.3363 42.2605 13.4289 42.2605 16.0102C42.2605 18.5914 40.1679 20.684 37.5866 20.684ZM8.80549 7.20466C3.94268 7.20466 0 11.1467 0 16.0102C0 20.8736 3.94207 24.8156 8.80549 24.8156C13.6689 24.8156 17.611 20.8736 17.611 16.0102C17.611 11.1467 13.6689 7.20466 8.80549 7.20466ZM8.80549 20.684C6.22422 20.684 4.13163 18.5914 4.13163 16.0102C4.13163 13.4289 6.22422 11.3363 8.80549 11.3363C11.3868 11.3363 13.4794 13.4289 13.4794 16.0102C13.4794 18.5914 11.3868 20.684 8.80549 20.684ZM17.6953 24.5331H21.9691L27.3723 0.0203115H23.0985L17.6953 24.5331ZM57.2729 7.48655L54.3642 20.684H53.6497L50.741 7.48655H46.4672L50.2246 24.5331H50.3563H53.5161L51.8704 32H56.1442L61.5474 7.48716L57.2729 7.48655Z"
  })));
};
var olby_logo_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgOlbyLogo);

/* harmony default export */ var olby_logo = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCA2MiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM3LjU4NjYgNy4yMDQ2NkMzNS45MTgxIDcuMjA0NjYgMzQuMzU4NSA3LjY2ODcyIDMzLjAyOTEgOC40NzQ5OVYwSDI4Ljc4MTdWMTYuMDEwMkMyOC43ODE3IDIwLjg3MyAzMi43MjM4IDI0LjgxNTYgMzcuNTg3MiAyNC44MTU2QzQyLjQ1MDYgMjQuODE1NiA0Ni4zOTI3IDIwLjg3MzYgNDYuMzkyNyAxNi4wMTAyQzQ2LjM5MjcgMTEuMTQ2NyA0Mi40NSA3LjIwNDY2IDM3LjU4NjYgNy4yMDQ2NlpNMzcuNTg2NiAyMC42ODRDMzUuMDA1MyAyMC42ODQgMzIuOTEyNyAxOC41OTE0IDMyLjkxMjcgMTYuMDEwMkMzMi45MTI3IDEzLjQyODkgMzUuMDA1MyAxMS4zMzYzIDM3LjU4NjYgMTEuMzM2M0M0MC4xNjc5IDExLjMzNjMgNDIuMjYwNSAxMy40Mjg5IDQyLjI2MDUgMTYuMDEwMkM0Mi4yNjA1IDE4LjU5MTQgNDAuMTY3OSAyMC42ODQgMzcuNTg2NiAyMC42ODRaTTguODA1NDkgNy4yMDQ2NkMzLjk0MjY4IDcuMjA0NjYgMCAxMS4xNDY3IDAgMTYuMDEwMkMwIDIwLjg3MzYgMy45NDIwNyAyNC44MTU2IDguODA1NDkgMjQuODE1NkMxMy42Njg5IDI0LjgxNTYgMTcuNjExIDIwLjg3MzYgMTcuNjExIDE2LjAxMDJDMTcuNjExIDExLjE0NjcgMTMuNjY4OSA3LjIwNDY2IDguODA1NDkgNy4yMDQ2NlpNOC44MDU0OSAyMC42ODRDNi4yMjQyMiAyMC42ODQgNC4xMzE2MyAxOC41OTE0IDQuMTMxNjMgMTYuMDEwMkM0LjEzMTYzIDEzLjQyODkgNi4yMjQyMiAxMS4zMzYzIDguODA1NDkgMTEuMzM2M0MxMS4zODY4IDExLjMzNjMgMTMuNDc5NCAxMy40Mjg5IDEzLjQ3OTQgMTYuMDEwMkMxMy40Nzk0IDE4LjU5MTQgMTEuMzg2OCAyMC42ODQgOC44MDU0OSAyMC42ODRaTTE3LjY5NTMgMjQuNTMzMUgyMS45NjkxTDI3LjM3MjMgMC4wMjAzMTE1SDIzLjA5ODVMMTcuNjk1MyAyNC41MzMxWk01Ny4yNzI5IDcuNDg2NTVMNTQuMzY0MiAyMC42ODRINTMuNjQ5N0w1MC43NDEgNy40ODY1NUg0Ni40NjcyTDUwLjIyNDYgMjQuNTMzMUg1MC4zNTYzSDUzLjUxNjFMNTEuODcwNCAzMkg1Ni4xNDQyTDYxLjU0NzQgNy40ODcxNkw1Ny4yNzI5IDcuNDg2NTVaIi8+Cjwvc3ZnPgo=");
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./pages/background.png
/* harmony default export */ var background = ({"src":"/_next/static/media/background.57d78ae5.png","height":1654,"width":3360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAJ1BMVEUOCwcPERQcICY6KSErLjYhGxIqJCQ5MjFuWlg6QEqJYl5aR0KKen3XIZoPAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAJ0lEQVQImWNgYGRiYWNkYADRHNxMjCAGJw8XOysDAwMbOzMzMysDAAdjAHU54D7yAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./pages/index.module.scss
var pages_index_module = __webpack_require__(232);
var pages_index_module_default = /*#__PURE__*/__webpack_require__.n(pages_index_module);
;// CONCATENATED MODULE: ./pages/index.tsx






const Index = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (pages_index_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: background,
                alt: "space",
                fill: true,
                sizes: "100vw",
                className: (pages_index_module_default()).image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (pages_index_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: (pages_index_module_default()).title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (pages_index_module_default()).jungle,
                                children: "Jungle Devs"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "is now",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (pages_index_module_default())["visually-hidden"],
                                children: "Olby"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(olby_logo_ForwardRef, {
                        className: (pages_index_module_default()).logo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAButton, {
                        variant: "white",
                        size: "medium",
                        href: "https://olby.com",
                        isExternal: true,
                        children: "Launch Website"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages = (Index);


/***/ }),

/***/ 232:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__08TqZ","image":"index_image__2GnP1","content":"index_content__k_CP2","title":"index_title__qVQRs","theme--light":"index_theme--light__pb4BV","theme--dark":"index_theme--dark__gZ0nv","jungle":"index_jungle__mqJlP","logo":"index_logo__jkwW_","visually-hidden":"index_visually-hidden__yyZsL","fade-in-up":"index_fade-in-up__LzcmM","fade-in-opacity":"index_fade-in-opacity__d_UVE","fade-in-up-opacity":"index_fade-in-up-opacity__1928X","fade-out-opacity":"index_fade-out-opacity__qByI9","fade-out-left":"index_fade-out-left__5VToX"};

/***/ }),

/***/ 8579:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"button_link__VCdDw","content":"button_content__ww7LJ","arrow-wrapper":"button_arrow-wrapper__D7KzQ","button-label":"button_button-label__2vBy5","large":"button_large__QhZHB","icon":"button_icon__ix2fV","medium":"button_medium__69Qyj","highlight":"button_highlight__5uvSX","theme--light":"button_theme--light__A2fZm","theme--dark":"button_theme--dark__NiIj7","primary":"button_primary__r9bak","secondary":"button_secondary__nR_xE","white":"button_white__Ln1lX","opacity":"button_opacity__zewbz","fade-in-up":"button_fade-in-up__4Yakx","fade-in-opacity":"button_fade-in-opacity__uiUG0","fade-in-up-opacity":"button_fade-in-up-opacity__CjxjG","fade-out-opacity":"button_fade-out-opacity__U5xnx","fade-out-left":"button_fade-out-left__QoJqj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [713,774,888,179], function() { return __webpack_exec__(7314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);